import DisciplineModal from './DisciplineModal'

export default DisciplineModal
